<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-ensino-medio')" class="main bg-white" id="about-main">
      <b-container id="center-y">
        <b-card class="w-100 p-2 bg-transparent border-0 mb-5 mb-md-0">
          <b-row>
            <b-col cols="12" md="4" lg="3" v-for="(list, index) in lists" :key="index">
              <router-link
                :to="{
                  name: 'render-conteudo-exclusivo',
                  params: { paramsForUrl: list.LinkFree },
                  query: { material: formatParam(list.description) },
                }"
              >
                <b-card
                  :img-src="list.src"
                  img-top
                  img-alt="Imagem de Capa do Material Experimentando Infantil 2 Maternal I"
                  class="mb-3"
                >
                  <h6 class="text-center two-colors">{{ list.title }}</h6>
                  <p class="text-center mt-2">{{ list.description }}</p>
                  <hr />
                  <p class="text-center">{{ list.journal }}</p>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'ENSINO MÉDIO',
      pageSubtitle: 'AULAS DIGITAIS - QUÍMICA',
      NamePermission: '',
      IndexPermission: '',
      lists: [
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142018/AULA-DIGITAL-EnsMed-QUIMICA-Cad-01-Cap-01.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Conceitos Fundamentais',
          segment: '',
          discipline: 'Química',
          description: 'Aula 01',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142026/AULA-DIGITAL-EnsMed-QUIMICA-Cad-01-Cap-02.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Transformações da Materia',
          segment: '',
          discipline: 'Química',
          description: 'Aula 02',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142032/AULA-DIGITAL-EnsMed-QUIMICA-Cad-01-Cap-03.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Substâncias Puras e Misturas',
          segment: '',
          discipline: 'Química',
          description: 'Aula 03',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142039/AULA-DIGITAL-EnsMed-QUIMICA-Cad-01-Cap-04.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Materiais de Laboratório',
          segment: '',
          discipline: 'Química',
          description: 'Aula 04',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142048/AULA-DIGITAL-EnsMed-QUIMICA-Cad-01-Cap-05.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Separação de Misturas',
          segment: '',
          discipline: 'Química',
          description: 'Aula 05',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142054/AULA-DIGITAL-EnsMed-QUIMICA-Cad-01-Cap-06.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Estrutura Atômica',
          segment: '',
          discipline: 'Química',
          description: 'Aula 06',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142101/AULA-DIGITAL-EnsMed-QUIMICA-Cad-01-Cap-07.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Classificação Periódica dos Elementos',
          segment: '',
          discipline: 'Química',
          description: 'Aula 07',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142131/AULA-DIGITAL-EnsMed-QUIMICA-Cad-02-Cap-08.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Ligações Químicas',
          segment: '',
          discipline: 'Química',
          description: 'Aula 08',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142140/AULA-DIGITAL-EnsMed-QUIMICA-Cad-02-Cap-09.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Polarização Molecular',
          segment: '',
          discipline: 'Química',
          description: 'Aula 09',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142146/AULA-DIGITAL-EnsMed-QUIMICA-Cad-02-Cap-10.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Forças de Atração Intermoleculares',
          segment: '',
          discipline: 'Química',
          description: 'Aula 10',
          toolTip: '',
          isbn: 'Aula Digital',
        },

        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142344/AULA-DIGITAL-EnsMed-QUIMICA-Cad-03-Cap-11.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Funções Inorgânicas ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 11',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142339/AULA-DIGITAL-EnsMed-QUIMICA-Cad-03-Cap-12.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química -  Reações Químicas ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 12',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142401/AULA-DIGITAL-EnsMed-QUIMICA-Cad-04-Cap-13.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Leis das Reações Químicas ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 13',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142418/AULA-DIGITAL-EnsMed-QUIMICA-Cad-04-Cap-14.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Massas Atômicas e Moleculares',
          segment: '',
          discipline: 'Química',
          description: 'Aula 14',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142432/AULA-DIGITAL-EnsMed-QUIMICA-Cad-05-Cap-15.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química -  O Estado Gasoso ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 15',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142440/AULA-DIGITAL-EnsMed-QUIMICA-Cad-05-Cap-16.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Teoria Cinética dos Gases ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 16',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22142446/AULA-DIGITAL-EnsMed-QUIMICA-Cad-05-Cap-17.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Cálculos Envolvendo Fórmulas',
          segment: '',
          discipline: 'Química',
          description: 'Aula 17',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143236/AULA-DIGITAL-EnsMed-QUIMICA-Cad-06-Cap-18.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Cálculo Estequiométrico ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 18',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143256/AULA-DIGITAL-EnsMed-QUIMICA-Cad-07-Cap-19.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Estado Líquido ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 19',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143303/AULA-DIGITAL-EnsMed-QUIMICA-Cad-07-Cap-20.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - As Dispersões ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 20',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143417/AULA-DIGITAL-EnsMed-QUIMICA-Cad-07-Cap-21.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Dispersões Coloidais ou Coloides e Soluções Verdadeiras  ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 21',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143427/AULA-DIGITAL-EnsMed-QUIMICA-Cad-07-Cap-22.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Propriedades Coligativas das Solucões ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 22',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143514/AULA-DIGITAL-EnsMed-QUI%C2%8DMICA-Cad-08-Cap-23.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Reações de Oxirredução ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 23',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143522/AULA-DIGITAL-EnsMed-QUIMICA-Cad-08-Cap-24.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Eletroquímica ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 24',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143528/AULA-DIGITAL-EnsMed-QUIMICA-Cad-08-Cap-25.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Termoquímica ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 25',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143534/AULA-DIGITAL-EnsMed-QUI%C2%8DMICA-Cad-08-Cap-26.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Química Descritiva ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 26',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143617/AULA-DIGITAL-EnsMed-QUI__MICA-Cad-09-Cap-27.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Cinética Química ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 27',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143638/AULA-DIGITAL-EnsMed-QUIMICA-Cad-09-Cap-28.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Equilíbrio Químico ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 28',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143705/AULA-DIGITAL-EnsMed-QUIMICA-Cad-10-Cap-29.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Radioatividade ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 29',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143712/AULA-DIGITAL-EnsMed-QUIMICA-Cad-10-Cap-30.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Química Orgânica ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 30',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143935/AULA-DIGITAL-EnsMed-QUIMICA-Cad-10-Cap-31.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Principais Funções Orgânicas ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 31',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143940/AULA-DIGITAL-EnsMed-QUIMICA-Cad-10-Cap-32.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química -  Alcoóis',
          segment: '',
          discipline: 'Química',
          description: 'Aula 32',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22143950/AULA-DIGITAL-EnsMed-QUIMICA-Cad-10-Cap-33.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Aminas ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 33',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144036/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-34.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Propriedades Físico Químicas dos Compostos Orgânicos',
          segment: '',
          discipline: 'Química',
          description: 'Aula 34',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144046/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-35.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Isomeria ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 35',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144054/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-36.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Reações Orgânicas',
          segment: '',
          discipline: 'Química',
          description: 'Aula 36',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144101/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-37.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Reações de Oxidação e Redução ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 37',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144108/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-38.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Reações de Oxidação e Redução',
          segment: '',
          discipline: 'Química',
          description: 'Aula 38',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144117/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-39.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Química Ambiental ',
          segment: '',
          discipline: 'Química',
          description: 'Aula 39',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144129/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-40.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Poluição do Ar',
          segment: '',
          discipline: 'Química',
          description: 'Aula 40',
          toolTip: '',
          isbn: 'Aula Digital',
        },
        {
          linkReaOnly: '',
          LinkFree:
            'https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2016/08/22144140/AULA-DIGITAL-EnsMed-QUIMICA-Cad-11-Cap-41.pdf',
          videoId: '',
          src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-aula-digital-2.png',
          bundle: 'E_medio',
          title: 'Química - Poluição da Água',
          segment: '',
          discipline: 'Química',
          description: 'Aula 41',
          toolTip: '',
          isbn: 'Aula Digital',
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>